import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { SchoolCard } from '@/entities/school'
import { useSchoolItem } from '@/shared/api/school'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/administration/reference-books/schools/$schoolId')({
  component: SchoolDetailLayout,
})

function SchoolDetailLayout() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()
  const { schoolId } = Route.useParams()
  const { data: school, isLoading, isError } = useSchoolItem({ id: schoolId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка школы')}>
      <SchoolCard school={school?.school} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
